// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const EndpointSourceSchema = z.enum(['TRACKING','CRAWLING','PROBING','MANUAL','COPILOT','AI','FEATURE_ANALYSIS','NAVIGATION_PROFILE','WIZ_INTEGRATION','UPWIND_INTEGRATION'] as const);

export type EndpointSourceType = `${z.infer<typeof EndpointSourceSchema>}`

export default EndpointSourceSchema;
